<div class="overlay-side-panel" id="sidebarItemOverlay">
    <div class="items-container-sidebar" id="sidebarItemContainer">
        <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
</div>